import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from "@angular/core";
import { MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";

@Component({
    selector: "app-receive-payment-view",
    templateUrl: "./receive-payment-view.component.html",
    styleUrls: ["./receive-payment-view.component.scss"],
})
export class ReceivePaymentViewComponent implements OnInit, OnChanges {
    @Input() receivePaymentId;
    receivePaymentDetail;

    constructor(
        private salesOrderService: SalesOrderService,
        private appMainService: AppMainService,
        private messageService: MessageService
    ) {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.receivePaymentId?.currentValue) {
            this.receivePaymentId = changes.receivePaymentId.currentValue;
            this.getReceivePaymentDetailsById(this.receivePaymentId);
        }
    }

    getReceivePaymentDetailsById(id) {
        this.receivePaymentDetail = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.salesOrderService.getReceivePaymentById(id).subscribe(
            (res) => {
                this.receivePaymentDetail = res;
                this.appMainService.isHideSpinner("loadDetails");
            },
            (err) => {
                this.appMainService.isHideSpinner("loadDetails");
                this.showErrorMsg(err);
            }
        );
    }

    showErrorMsg(err) {
        this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred...",
        });
    }
}
